import {
    createContext,
    useContext,
    useEffect,
    useState,
} from 'react';

const traducciones = {
    /* ===================================================
       ESPAÑOL
       =================================================== */

    es: {
        navbar: {
            inicio: 'Inicio',
            sobreMi: 'Sobre mí',
            servicios: 'Servicios',
            testimonios: 'Testimonios',
            blog: 'Blog',
            contacto: 'Contacto',
        },

        hero: {
            imagenAlt: 'José Manuel Martín',

            frase1: {
                linea1: 'Para sobrevivir en el bosque,',
                linea2: 'entiende que estás en él;',
            },

            frase2: {
                linea1: 'para prosperar en el bosque,',
                linea2: 'aprende a escucharlo;',
            },

            frase3: {
                linea1: 'para abrir tu camino en él,',
                linea2: 'utiliza lo que te dice.',
            },

            descripcion:
                'Acompaño a personas y organizaciones a leer el contexto, ganar claridad y avanzar con sentido.',

            boton: 'Hablemos',
        },

        serviciosInicio: {
            titulo: 'Cómo puedo acompañarte',
            saberMas: 'Saber más',

            coaching: {
                titulo: 'Coaching individual',
                descripcion:
                    'Un espacio para ganar claridad, explorar posibilidades y avanzar hacia tus objetivos.',
            },

            facilitacion: {
                titulo:
                    'Facilitación y procesos colectivos',
                descripcion:
                    'Acompañamiento a grupos y organizaciones para construir caminos compartidos.',
            },

            cambio: {
                titulo:
                    'Procesos de cambio sistémico y territorial',
                descripcion:
                    'Impulso de transformaciones sostenibles conectadas con las necesidades de cada territorio.',
            },
        },
        sobreMiInicio: {
            etiqueta: 'Sobre mí',

            titulo:
                'Acompaño a personas y organizaciones en sus procesos de cambio',

            descripcion:
                'Soy José Manuel Martín, facilitador y coach especializado en acompañar a personas, equipos y organizaciones. Mi trabajo consiste en ayudarles a comprender mejor su contexto, encontrar claridad y avanzar de una forma consciente y coherente.',

            botonContacto: 'Contáctame',
            botonSaberMas: 'Saber más sobre mí',

            imagenAlt: 'José Manuel Martín',
        },
        testimoniosInicio: {
            titulo:
                'Testimonios de quienes han trabajado conmigo',

            verTodos: 'Ver todos los testimonios',
        },
        clientes: {
            titulo: 'He trabajado con',
            logoAlt: 'Logo de',
        },
        manualInicio: {
            titulo: 'Manuales y publicaciones',
            descargar: 'Descargar',
            enPdf: 'en PDF',
            portada: 'Portada de',
            descargarPdf: 'Descargar PDF',

            autores: {
                coautor: 'Coautor',
                contribuidor: 'Contribuidor',
            },
        },
        footer: {
            descripcion:
                'Más de diez años diseñando y facilitando procesos de innovación, aprendizaje y transformación para instituciones públicas, empresas y proyectos europeos.',

            formacion: {
                doctorado:
                    'Doctor en Lingüística Aplicada y Teoría de la Comunicación.',

                master:
                    'Máster en Metodologías de Investigación, Desarrollo e Innovación.',

                coach: 'Coach certificado.',

                formador: 'Formador de Formadores.',
            },

            navegacion: {
                titulo: 'Navegación',
                inicio: 'Inicio',
                sobreMi: 'Sobre mí',
                servicios: 'Servicios',
                testimonios: 'Testimonios',
                blog: 'Blog',
            },

            contacto: {
                titulo: 'Contacto',
                enlace: 'Hablemos',
            },

            redesSociales: 'Redes sociales',

            derechos:
                'Todos los derechos reservados.',

            legal: {
                aviso: 'Aviso legal',
                privacidad: 'Política de privacidad',
                cookies: 'Política de cookies',
            },
        },
        sobreMiPagina: {
            recorrido: {
                etiqueta: 'Sobre mí',

                titulo:
                    'Conoce mi recorrido y mi forma de trabajar',

                parrafos: [
                    'Durante años trabajé como investigador y especialista en innovación, diseñando metodologías participativas y acompañando proyectos europeos en colaboración con administraciones públicas, empresas, universidades y organizaciones sociales.',

                    'Trabajar en equipos internacionales y multiculturales me enseñó que los mayores retos rara vez son técnicos: suelen aparecer en las conversaciones, en la toma de decisiones y en la forma en que las personas construyen una visión compartida.',

                    'Con el tiempo comprendí que mi mayor aportación no era solo diseñar procesos, sino crear las condiciones para que las personas pudieran pensar juntas con más claridad, confianza y profundidad. Esa intuición me llevó de la investigación al coaching y la facilitación.',

                    'A lo largo de este recorrido he contribuido al desarrollo de metodologías como Challenge-Led System Mapping, utilizada en proyectos de la Comisión Europea para abordar retos complejos mediante pensamiento sistémico y co-creación.',

                    'También he trabajado en innovación educativa, formación, emprendimiento y diseño de procesos de aprendizaje. Además, he sido docente —y lo he disfrutado muy genuinamente— de asignaturas universitarias como Teoría de la Innovación, Gestión de Riesgos de Proyectos o Modelos de Negocio de Economía Circular.',

                    'Hoy acompaño a personas, equipos e instituciones que atraviesan momentos de cambio. Me interesa especialmente facilitar conversaciones complejas, generar espacios de confianza y ayudar a transformar la complejidad en decisiones más claras y acciones coherentes.',
                ],

                boton: 'Hablemos',

                imagenAlt: 'José Manuel Martín',
            },

            manifiesto: {
                titulo:
                    'Ayudar a mirar mejor antes de decidir',

                parrafos: [
                    'No creo que el mundo necesite más expertos diciendo a los demás lo que deben hacer; creo que necesita más personas capaces de observar antes de reaccionar, más conversaciones que produzcan comprensión y más espacios donde pensar sin prisa.',

                    'Hemos creído que rodearnos de información nos daría automáticamente claridad. Hemos confundido actividad con avance, frenesí con agilidad y multitarea con fluidez. Creemos que la rapidez es sinónimo de eficacia y que la complejidad nos obliga a complicarnos.',

                    'Mi trabajo consiste en detener ese impulso.',

                    'Ayudar a mirar mejor antes de decidir.',

                    'Crear espacios donde las personas puedan escucharse de verdad, donde los equipos recuperen una visión compartida y donde las organizaciones puedan actuar desde la coherencia, en lugar de hacerlo únicamente desde la urgencia.',

                    'No vendo respuestas prefabricadas. No creo en recetas universales. No tengo ni una solución mágica.',

                    'Creo en los procesos que ayudan a desarrollar mejores criterios de observación. Y creo en la toma de decisiones que viene con esos criterios.',

                    'Cuando cambia la forma de observar un problema, también cambia la forma de vivirlo.',

                    'Y cuando cambia la mirada, el cambio deja de sentirse impuesto y empieza a surgir desde dentro.',
                ],
            },

            principios: {
                titulo:
                    'Los principios que orientan mi forma de acompañar',

                imagenAlt:
                    'José Manuel Martín durante una sesión de trabajo',

                lista: [
                    {
                        titulo:
                            'La claridad precede al cambio',

                        descripcion:
                            'Ninguna herramienta sustituye una comprensión profunda de la realidad.',
                    },

                    {
                        titulo: 'Todo sistema habla',

                        descripcion:
                            'Personas, equipos y organizaciones muestran continuamente la información necesaria para avanzar. Solo hay que aprender a verla.',
                    },

                    {
                        titulo:
                            'La coherencia genera más movimiento que la motivación',

                        descripcion:
                            'Lo que está alineado perdura; lo que depende únicamente del entusiasmo suele agotarse.',
                    },

                    {
                        titulo:
                            'Las preguntas transforman más que las respuestas',

                        descripcion:
                            'Una buena pregunta abre posibilidades que ninguna solución impuesta puede ofrecer.',
                    },

                    {
                        titulo:
                            'Las personas son las protagonistas del proceso',

                        descripcion:
                            'Mi trabajo consiste en facilitar, no en dirigir.',
                    },

                    {
                        titulo: 'El objetivo es la autonomía',

                        descripcion:
                            'Un buen acompañamiento termina cuando ya no hace falta.',
                    },

                    {
                        titulo:
                            'La complejidad merece respeto',

                        descripcion:
                            'No simplifico lo importante. Busco hacerlo comprensible sin perder su profundidad.',
                    },
                ],

                boton: 'Cuéntame tu situación',
            },
        },
        miEstilo: {

            titulo: 'Mi estilo',

            introduccion:
                'Una manera de acompañar basada en la escucha, la colaboración y la transformación de las ideas en decisiones y acciones concretas.',
        },
        serviciosPagina: {
            etiqueta: 'Servicios',

            titulo:
                'Procesos adaptados a cada persona y organización',

            verOpciones: 'Ver opciones',
            cerrar: 'Cerrar ventana',
            servicio: 'Servicio',
            planes: 'Planes',
            paraQuien: 'Para quién',
            formato: 'Formato',

            solicitarInformacion:
                'Solicitar información',
        },
        testimoniosPagina: {
            etiqueta: 'Testimonios',

            titulo:
                'Experiencias de personas y organizaciones',
        },
        contacto: {
            etiqueta: 'Contacto',

            titulo: '¿Hablamos?',

            descripcion:
                'Cuéntame qué necesitas y encontramos juntos el mejor camino.',

            aclaracion:
                'La fecha y hora seleccionadas son orientativas. Te confirmaré posteriormente la disponibilidad.',

            formulario: {
                nombre: 'Nombre',
                email: 'Correo electrónico',
                asunto: 'Asunto',
                consultaGeneral: 'Consulta general',
                otroAsunto: 'Otro asunto',
                escribirAsunto: 'Escribe el asunto',
                fecha: 'Fecha preferida',
                hora: 'Hora preferida',

                mensaje:
                    'Cuéntame el motivo de tu consulta',

                privacidadInicio:
                    'He leído y acepto la',

                privacidadEnlace:
                    'política de privacidad',

                enviar: 'Enviar consulta',
                enviando: 'Enviando...',
            },

            estado: {
                exito:
                    'Consulta enviada correctamente. Nos pondremos en contacto contigo lo antes posible.',

                error:
                    'No se pudo enviar la consulta. Inténtalo de nuevo.',
            },
        },
        avisoLegal: {
            etiqueta: 'Información legal',
            titulo: 'Aviso legal',

            ultimaActualizacion:
                'Última actualización: 02/09/2026',

            identificacion: {
                titulo: '1. Datos identificativos',

                descripcion:
                    'En cumplimiento de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico, se informa de que este sitio web pertenece a:',

                titular: 'Titular',
                nif: 'NIF',
                domicilio: 'Domicilio profesional',
                email: 'Correo electrónico',
                web: 'Sitio web',
            },

            objeto: {
                titulo: '2. Objeto del sitio web',

                descripcion:
                    'Este sitio web tiene como finalidad presentar los servicios profesionales de coaching, facilitación, formación y acompañamiento de procesos ofrecidos por su titular, así como permitir que las personas interesadas soliciten información o contacten con él.',
            },

            condiciones: {
                titulo: '3. Condiciones de uso',

                parrafos: [
                    'El acceso y uso de este sitio web atribuye la condición de usuario e implica la aceptación de las presentes condiciones.',

                    'El usuario se compromete a utilizar el sitio web y sus contenidos de forma lícita, responsable y conforme a la buena fe, absteniéndose de realizar acciones que puedan dañar, inutilizar o sobrecargar el sitio web.',
                ],
            },

            propiedad: {
                titulo:
                    '4. Propiedad intelectual e industrial',

                parrafos: [
                    'Los textos, imágenes, diseños, logotipos, publicaciones, materiales y demás contenidos de este sitio web son propiedad de su titular o se utilizan con la autorización correspondiente.',

                    'No se permite su reproducción, distribución, transformación o utilización con fines comerciales sin autorización previa y por escrito, salvo en los casos permitidos legalmente.',
                ],
            },

            responsabilidad: {
                titulo: '5. Responsabilidad',

                parrafos: [
                    'El titular procura que la información publicada sea correcta y esté actualizada, pero no garantiza la inexistencia de errores ni la disponibilidad ininterrumpida del sitio web.',

                    'Los contenidos tienen carácter informativo y no sustituyen el asesoramiento específico que pueda requerir cada persona u organización.',
                ],
            },

            enlaces: {
                titulo: '6. Enlaces externos',

                descripcion:
                    'Este sitio puede contener enlaces a páginas de terceros. El titular no controla sus contenidos ni se responsabiliza de sus políticas, disponibilidad o prácticas.',
            },

            legislacion: {
                titulo: '7. Legislación aplicable',

                descripcion:
                    'Estas condiciones se rigen por la legislación española. Cualquier controversia se someterá a los juzgados y tribunales que correspondan de acuerdo con la normativa aplicable.',
            },
        },
        privacidad: {
            etiqueta: 'Protección de datos',
            titulo: 'Política de privacidad',

            ultimaActualizacion:
                'Última actualización: 02/09/2026',

            responsable: {
                titulo:
                    '1. Responsable del tratamiento',

                nombre: 'Responsable',
                nif: 'NIF',
                email: 'Correo electrónico',
                domicilio: 'Domicilio profesional',
            },

            datos: {
                titulo: '2. Datos que se recopilan',

                introduccion:
                    'Mediante el formulario de contacto pueden recopilarse los siguientes datos:',

                lista: [
                    'Nombre.',
                    'Correo electrónico.',
                    'Servicio o asunto seleccionado.',
                    'Fecha y hora preferidas.',
                    'Contenido del mensaje.',
                ],

                aviso:
                    'Se recomienda no incluir información especialmente sensible en el mensaje.',
            },

            finalidad: {
                titulo:
                    '3. Finalidad del tratamiento',

                introduccion:
                    'Los datos serán utilizados para:',

                lista: [
                    'Responder consultas y solicitudes de información.',

                    'Gestionar posibles reuniones o servicios profesionales.',

                    'Mantener las comunicaciones necesarias relacionadas con la solicitud.',
                ],

                aviso:
                    'La fecha y la hora indicadas en el formulario son una preferencia y no constituyen una reserva confirmada.',
            },

            baseJuridica: {
                titulo: '4. Base jurídica',

                parrafos: [
                    'El tratamiento se basa en el consentimiento otorgado por el usuario al marcar la casilla de aceptación y enviar el formulario.',

                    'Cuando la consulta esté relacionada con la contratación de un servicio, el tratamiento también podrá ser necesario para aplicar medidas precontractuales solicitadas por el interesado.',
                ],
            },

            conservacion: {
                titulo:
                    '5. Conservación de los datos',

                parrafos: [
                    'Los datos se conservarán durante el tiempo necesario para atender la solicitud y mantener las comunicaciones correspondientes.',

                    'Posteriormente podrán conservarse bloqueados durante los plazos exigidos para atender posibles responsabilidades legales. Las consultas que no den lugar a una relación profesional serán eliminadas cuando dejen de ser necesarias.',
                ],
            },

            proveedores: {
                titulo:
                    '6. Destinatarios y proveedores',

                noCesion:
                    'Los datos no serán vendidos ni cedidos a terceros, salvo obligación legal.',

                introduccion:
                    'Para alojar la web y enviar los mensajes pueden utilizarse proveedores tecnológicos que actuarán como encargados del tratamiento:',

                alojamiento:
                    'Alojamiento, CDN y funciones web',

                envioCorreo:
                    'Envío y encaminamiento del correo electrónico',

                medianteCloudflare:
                    'mediante Cloudflare Email Service.',

                recepcionCorreo:
                    'Recepción y almacenamiento del correo',

                medianteGmail: 'mediante Gmail.',

                transferencias:
                    'Algunos proveedores pueden realizar transferencias internacionales de datos utilizando los mecanismos reconocidos por la normativa aplicable.',
            },

            derechos: {
                titulo:
                    '7. Derechos de las personas usuarias',

                descripcion:
                    'Puedes solicitar el acceso, rectificación, supresión, oposición, limitación o portabilidad de tus datos, así como retirar el consentimiento, escribiendo a',

                solicitud:
                    'La solicitud deberá indicar qué derecho deseas ejercer e incluir la información necesaria para comprobar tu identidad.',

                reclamacionInicio:
                    'También puedes presentar una reclamación ante la',

                aepd:
                    'Agencia Española de Protección de Datos',
            },

            seguridad: {
                titulo: '8. Seguridad',

                descripcion:
                    'Se adoptarán medidas técnicas y organizativas razonables para proteger los datos personales frente a su pérdida, alteración, acceso o divulgación no autorizados.',
            },

            cambios: {
                titulo:
                    '9. Cambios en esta política',

                descripcion:
                    'Esta política podrá actualizarse cuando cambien los servicios, los proveedores utilizados o la normativa aplicable. La versión vigente estará disponible en esta página.',
            },
        },
        cookies: {
            etiqueta: 'Información legal',
            titulo: 'Política de cookies',

            ultimaActualizacion:
                'Última actualización: 02/09/2026',

            definicion: {
                titulo: '1. ¿Qué son las cookies?',

                descripcion:
                    'Las cookies son pequeños archivos que pueden almacenarse en el dispositivo del usuario al visitar una página web. Sirven, entre otras funciones, para permitir el funcionamiento técnico de la web, recordar preferencias o analizar el uso del sitio.',
            },

            utilizadas: {
                titulo:
                    '2. Cookies y almacenamiento utilizados en este sitio',

                parrafos: [
                    'Actualmente este sitio web no utiliza cookies propias o de terceros con finalidades publicitarias, analíticas o de elaboración de perfiles.',

                    'El sitio utiliza el almacenamiento local del navegador para recordar el idioma seleccionado por el usuario. Esta información permanece únicamente en el dispositivo y no se utiliza para identificar al usuario, analizar su comportamiento ni mostrar publicidad personalizada.',

                    'También podrían utilizarse elementos técnicos estrictamente necesarios para la seguridad, el funcionamiento o la prestación del servicio. Estos elementos no requieren consentimiento cuando resultan imprescindibles para prestar el servicio solicitado por el usuario.',
                ],
            },

            terceros: {
                titulo: '3. Servicios de terceros',

                parrafos: [
                    'La web se aloja mediante Cloudflare. Este proveedor puede emplear mecanismos técnicos necesarios para proteger el sitio, detectar tráfico malicioso y garantizar su funcionamiento.',

                    'Los enlaces a páginas externas no implican que dichas páginas utilicen las mismas políticas. Se recomienda consultar la política de cookies de cada servicio externo.',
                ],
            },

            gestion: {
                titulo:
                    '4. Gestión de cookies y almacenamiento',

                descripcion:
                    'El usuario puede configurar su navegador para bloquear, eliminar o recibir avisos sobre las cookies y borrar los datos almacenados localmente. El bloqueo de elementos estrictamente necesarios puede afectar al funcionamiento de determinadas páginas o impedir que se recuerde el idioma elegido.',
            },

            futuro: {
                titulo:
                    '5. Incorporación futura de nuevas cookies',

                descripcion:
                    'Si en el futuro se incorporan herramientas analíticas, publicitarias, vídeos incrustados u otros servicios que instalen cookies no necesarias, esta política será actualizada y se mostrará un sistema que permita aceptar, rechazar o configurar dichas cookies antes de su instalación.',
            },

            contacto: {
                titulo: '6. Contacto',

                descripcion:
                    'Para cualquier consulta relacionada con esta política, puedes escribir a',
            },

        },
    },

    /* ===================================================
       INGLÉS
       =================================================== */

    en: {
        navbar: {
            inicio: 'Home',
            sobreMi: 'About me',
            servicios: 'Services',
            testimonios: 'Testimonials',
            blog: 'Blog',
            contacto: 'Contact',
        },

        hero: {
            imagenAlt: 'José Manuel Martín',

            frase1: {
                linea1: 'To survive in the forest,',
                linea2: 'understand that you are in it;',
            },

            frase2: {
                linea1: 'to thrive in the forest,',
                linea2: 'learn to listen to it;',
            },

            frase3: {
                linea1: 'to find your way through it,',
                linea2: 'use what it tells you.',
            },

            descripcion:
                'I support people and organisations in understanding their context, gaining clarity and moving forward with purpose.',

            boton: "Let's talk",
        },

        serviciosInicio: {
            titulo: 'How I can support you',
            saberMas: 'Learn more',

            coaching: {
                titulo: 'Individual coaching',
                descripcion:
                    'A space to gain clarity, explore possibilities and move towards your goals.',
            },

            facilitacion: {
                titulo:
                    'Facilitation and collective processes',
                descripcion:
                    'Support for groups and organisations to build shared paths.',
            },

            cambio: {
                titulo:
                    'Systemic and territorial change processes',
                descripcion:
                    'Promoting sustainable transformations connected to the needs of each territory.',
            },
        },
        sobreMiInicio: {
            etiqueta: 'About me',

            titulo:
                'I support people and organisations through their change processes',

            descripcion:
                'I am José Manuel Martín, a facilitator and coach specialising in supporting individuals, teams and organisations. My work consists of helping them better understand their context, gain clarity and move forward in a conscious and coherent way.',

            botonContacto: 'Contact me',
            botonSaberMas: 'Learn more about me',

            imagenAlt: 'José Manuel Martín',
        },
        testimoniosInicio: {
            titulo:
                'Testimonials from people who have worked with me',

            verTodos: 'View all testimonials',
        },
        clientes: {
            titulo: 'I have worked with',
            logoAlt: 'Logo of',
        },
        manualInicio: {
            titulo: 'Guides and publications',
            descargar: 'Download',
            enPdf: 'as a PDF',
            portada: 'Cover of',
            descargarPdf: 'Download PDF',

            autores: {
                coautor: 'Co-author',
                contribuidor: 'Contributor',
            },
        },
        footer: {
            descripcion:
                'More than ten years designing and facilitating innovation, learning and transformation processes for public institutions, companies and European projects.',

            formacion: {
                doctorado:
                    'PhD in Applied Linguistics and Communication Theory.',

                master:
                    "Master's Degree in Research, Development and Innovation Methodologies.",

                coach: 'Certified coach.',

                formador: 'Certified trainer of trainers.',
            },

            navegacion: {
                titulo: 'Navigation',
                inicio: 'Home',
                sobreMi: 'About me',
                servicios: 'Services',
                testimonios: 'Testimonials',
                blog: 'Blog',
            },

            contacto: {
                titulo: 'Contact',
                enlace: "Let's talk",
            },

            redesSociales: 'Social media',

            derechos: 'All rights reserved.',

            legal: {
                aviso: 'Legal notice',
                privacidad: 'Privacy policy',
                cookies: 'Cookie policy',
            },
        },
        sobreMiPagina: {
            recorrido: {
                etiqueta: 'About me',

                titulo:
                    'Discover my journey and the way I work',

                parrafos: [
                    'For years, I worked as a researcher and innovation specialist, designing participatory methodologies and supporting European projects in collaboration with public administrations, companies, universities and social organisations.',

                    'Working in international and multicultural teams taught me that the greatest challenges are rarely technical. They usually arise in conversations, decision-making and the way people build a shared vision.',

                    'Over time, I realised that my greatest contribution was not simply designing processes, but creating the conditions for people to think together with greater clarity, trust and depth. This insight led me from research to coaching and facilitation.',

                    'Throughout this journey, I have contributed to the development of methodologies such as Challenge-Led System Mapping, used in European Commission projects to address complex challenges through systems thinking and co-creation.',

                    'I have also worked in educational innovation, training, entrepreneurship and the design of learning processes. I have also taught —and genuinely enjoyed teaching— university subjects such as Innovation Theory, Project Risk Management and Circular Economy Business Models.',

                    'Today, I support individuals, teams and institutions going through periods of change. I am particularly interested in facilitating complex conversations, creating spaces of trust and helping transform complexity into clearer decisions and coherent actions.',
                ],

                boton: "Let's talk",

                imagenAlt: 'José Manuel Martín',
            },

            manifiesto: {
                titulo:
                    'Helping people see more clearly before deciding',

                parrafos: [
                    'I do not believe the world needs more experts telling others what they should do. I believe it needs more people capable of observing before reacting, more conversations that create understanding and more spaces where people can think without rushing.',

                    'We have believed that surrounding ourselves with information would automatically give us clarity. We have confused activity with progress, frenzy with agility and multitasking with fluidity. We believe that speed is synonymous with effectiveness and that complexity requires us to make things complicated.',

                    'My work is about stopping that impulse.',

                    'Helping people see more clearly before deciding.',

                    'Creating spaces where people can genuinely listen to one another, where teams can recover a shared vision and where organisations can act coherently rather than responding solely to urgency.',

                    'I do not sell ready-made answers. I do not believe in universal formulas. I do not have a magic solution.',

                    'I believe in processes that help people develop better criteria for observation. And I believe in the decision-making that emerges from those criteria.',

                    'When the way we observe a problem changes, the way we experience it also changes.',

                    'And when our perspective changes, change no longer feels imposed and begins to emerge from within.',
                ],
            },

            principios: {
                titulo:
                    'The principles that guide the way I support others',

                imagenAlt:
                    'José Manuel Martín during a working session',

                lista: [
                    {
                        titulo:
                            'Clarity comes before change',

                        descripcion:
                            'No tool can replace a deep understanding of reality.',
                    },

                    {
                        titulo: 'Every system communicates',

                        descripcion:
                            'People, teams and organisations continuously reveal the information needed to move forward. We only need to learn how to see it.',
                    },

                    {
                        titulo:
                            'Coherence creates more movement than motivation',

                        descripcion:
                            'What is aligned endures; what depends solely on enthusiasm usually fades.',
                    },

                    {
                        titulo:
                            'Questions transform more than answers',

                        descripcion:
                            'A good question opens possibilities that no imposed solution can offer.',
                    },

                    {
                        titulo:
                            'People are the protagonists of the process',

                        descripcion:
                            'My role is to facilitate, not to direct.',
                    },

                    {
                        titulo: 'The goal is autonomy',

                        descripcion:
                            'Good support ends when it is no longer needed.',
                    },

                    {
                        titulo:
                            'Complexity deserves respect',

                        descripcion:
                            'I do not oversimplify what matters. I seek to make it understandable without losing its depth.',
                    },
                ],

                boton: 'Tell me about your situation',
            },
        },
        miEstilo: {
            etiqueta: 'How I work',

            titulo: 'My approach',

            introduccion:
                'An approach to supporting others based on listening, collaboration and transforming ideas into concrete decisions and actions.',
        },
        serviciosPagina: {
            etiqueta: 'Services',

            titulo:
                'Processes tailored to each individual and organisation',

            verOpciones: 'View options',
            cerrar: 'Close window',
            servicio: 'Service',
            planes: 'Plans',
            paraQuien: 'Who it is for',
            formato: 'Format',

            solicitarInformacion:
                'Request information',
        },
        testimoniosPagina: {
            etiqueta: 'Testimonials',

            titulo:
                'Experiences shared by individuals and organisations',
        },
        contacto: {
            etiqueta: 'Contact',

            titulo: 'Shall we talk?',

            descripcion:
                'Tell me what you need and together we will find the best way forward.',

            aclaracion:
                'The selected date and time are provisional. I will confirm availability with you afterwards.',

            formulario: {
                nombre: 'Name',
                email: 'Email address',
                asunto: 'Subject',
                consultaGeneral: 'General enquiry',
                otroAsunto: 'Other subject',
                escribirAsunto: 'Enter the subject',
                fecha: 'Preferred date',
                hora: 'Preferred time',

                mensaje:
                    'Tell me the reason for your enquiry',

                privacidadInicio:
                    'I have read and accept the',

                privacidadEnlace:
                    'privacy policy',

                enviar: 'Send enquiry',
                enviando: 'Sending...',
            },

            estado: {
                exito:
                    'Your enquiry has been sent successfully. We will contact you as soon as possible.',

                error:
                    'Your enquiry could not be sent. Please try again.',
            },
        },
        avisoLegal: {
            etiqueta: 'Legal information',
            titulo: 'Legal notice',

            ultimaActualizacion:
                'Last updated: 2 September 2026',

            identificacion: {
                titulo: '1. Identification details',

                descripcion:
                    'In compliance with Spanish Act 34/2002 of 11 July on Information Society Services and Electronic Commerce, users are informed that this website belongs to:',

                titular: 'Owner',
                nif: 'Tax identification number',
                domicilio: 'Professional address',
                email: 'Email address',
                web: 'Website',
            },

            objeto: {
                titulo: '2. Purpose of the website',

                descripcion:
                    'The purpose of this website is to present the professional coaching, facilitation, training and process-support services offered by its owner, as well as to allow interested parties to request information or contact him.',
            },

            condiciones: {
                titulo: '3. Terms of use',

                parrafos: [
                    'Accessing and using this website grants the status of user and implies acceptance of these terms.',

                    'Users agree to use the website and its content lawfully, responsibly and in good faith, refraining from actions that could damage, disable or overload the website.',
                ],
            },

            propiedad: {
                titulo:
                    '4. Intellectual and industrial property',

                parrafos: [
                    'The texts, images, designs, logos, publications, materials and other content on this website belong to its owner or are used with the corresponding authorisation.',

                    'Their reproduction, distribution, transformation or use for commercial purposes is not permitted without prior written authorisation, except where legally permitted.',
                ],
            },

            responsabilidad: {
                titulo: '5. Liability',

                parrafos: [
                    'The owner endeavours to ensure that the published information is correct and up to date but does not guarantee the absence of errors or the uninterrupted availability of the website.',

                    'The content is provided for informational purposes and does not replace the specific advice that an individual or organisation may require.',
                ],
            },

            enlaces: {
                titulo: '6. External links',

                descripcion:
                    'This website may contain links to third-party websites. The owner does not control their content and accepts no responsibility for their policies, availability or practices.',
            },

            legislacion: {
                titulo: '7. Applicable law',

                descripcion:
                    'These terms are governed by Spanish law. Any dispute shall be submitted to the competent courts and tribunals in accordance with the applicable regulations.',
            },
        },
        privacidad: {
            etiqueta: 'Data protection',
            titulo: 'Privacy policy',

            ultimaActualizacion:
                'Last updated: 2 September 2026',

            responsable: {
                titulo: '1. Data controller',

                nombre: 'Data controller',
                nif: 'Tax identification number',
                email: 'Email address',
                domicilio: 'Professional address',
            },

            datos: {
                titulo: '2. Data collected',

                introduccion:
                    'The following personal data may be collected through the contact form:',

                lista: [
                    'Name.',
                    'Email address.',
                    'Selected service or subject.',
                    'Preferred date and time.',
                    'Message content.',
                ],

                aviso:
                    'Users are advised not to include particularly sensitive information in their messages.',
            },

            finalidad: {
                titulo:
                    '3. Purpose of the processing',

                introduccion:
                    'The data will be used to:',

                lista: [
                    'Respond to enquiries and requests for information.',

                    'Manage potential meetings or professional services.',

                    'Maintain the communications necessary in relation to the request.',
                ],

                aviso:
                    'The date and time entered in the form indicate a preference and do not constitute a confirmed booking.',
            },

            baseJuridica: {
                titulo: '4. Legal basis',

                parrafos: [
                    'The processing is based on the consent given by the user when they select the acceptance checkbox and submit the form.',

                    'When an enquiry relates to the potential engagement of a service, the processing may also be necessary to take pre-contractual steps requested by the interested party.',
                ],
            },

            conservacion: {
                titulo: '5. Data retention',

                parrafos: [
                    'The data will be retained for as long as necessary to deal with the request and maintain the corresponding communications.',

                    'The data may subsequently be retained in a restricted form for the periods required to address potential legal liabilities. Enquiries that do not result in a professional relationship will be deleted when they are no longer necessary.',
                ],
            },

            proveedores: {
                titulo:
                    '6. Recipients and service providers',

                noCesion:
                    'Personal data will not be sold or disclosed to third parties unless required by law.',

                introduccion:
                    'Technology providers may be used to host the website and send messages. These providers will act as data processors:',

                alojamiento:
                    'Website hosting, CDN and web functions',

                envioCorreo:
                    'Email sending and routing',

                medianteCloudflare:
                    'through Cloudflare Email Service.',

                recepcionCorreo:
                    'Email reception and storage',

                medianteGmail: 'through Gmail.',

                transferencias:
                    'Some providers may carry out international data transfers using mechanisms recognised by the applicable data-protection regulations.',
            },

            derechos: {
                titulo: '7. User rights',

                descripcion:
                    'You may request access to, rectification or erasure of your data, object to or restrict its processing, request data portability or withdraw your consent by writing to',

                solicitud:
                    'Your request must specify the right you wish to exercise and include the information required to verify your identity.',

                reclamacionInicio:
                    'You may also submit a complaint to the',

                aepd:
                    'Spanish Data Protection Agency',
            },

            seguridad: {
                titulo: '8. Security',

                descripcion:
                    'Reasonable technical and organisational measures will be adopted to protect personal data against loss, alteration, unauthorised access or disclosure.',
            },

            cambios: {
                titulo:
                    '9. Changes to this policy',

                descripcion:
                    'This policy may be updated when the services, providers or applicable regulations change. The current version will remain available on this page.',
            },
        },
        cookies: {
            etiqueta: 'Legal information',
            titulo: 'Cookie policy',

            ultimaActualizacion:
                'Last updated: 2 September 2026',

            definicion: {
                titulo: '1. What are cookies?',

                descripcion:
                    'Cookies are small files that may be stored on a user’s device when they visit a website. Among other purposes, they can enable the technical operation of a website, remember preferences or analyse how the website is used.',
            },

            utilizadas: {
                titulo:
                    '2. Cookies and storage used on this website',

                parrafos: [
                    'This website does not currently use first-party or third-party cookies for advertising, analytics or profiling purposes.',

                    'The website uses the browser’s local storage to remember the language selected by the user. This information remains on the user’s device and is not used to identify the user, analyse their behaviour or display personalised advertising.',

                    'Strictly necessary technical elements may also be used to ensure the security, operation or provision of the service. These elements do not require consent when they are essential to provide a service requested by the user.',
                ],
            },

            terceros: {
                titulo: '3. Third-party services',

                parrafos: [
                    'The website is hosted through Cloudflare. This provider may use technical mechanisms necessary to protect the website, detect malicious traffic and ensure its operation.',

                    'Links to external websites do not mean that those websites follow the same policies. Users are advised to consult the cookie policy of each external service.',
                ],
            },

            gestion: {
                titulo:
                    '4. Managing cookies and storage',

                descripcion:
                    'Users can configure their browser to block, delete or receive notifications about cookies and remove locally stored data. Blocking strictly necessary elements may affect the operation of certain pages or prevent the selected language from being remembered.',
            },

            futuro: {
                titulo:
                    '5. Future use of new cookies',

                descripcion:
                    'If analytics or advertising tools, embedded videos or other services that install non-essential cookies are added in the future, this policy will be updated and a system will be displayed allowing users to accept, reject or configure those cookies before they are installed.',
            },

            contacto: {
                titulo: '6. Contact',

                descripcion:
                    'If you have any questions regarding this policy, you can write to',
            },
        },

    },
};

const IdiomaContext = createContext();

function obtenerTraduccion(objeto, ruta) {
    return ruta
        .split('.')
        .reduce(
            (resultado, propiedad) =>
                resultado?.[propiedad],
            objeto
        );
}

export function IdiomaProvider({ children }) {
    const [idioma, setIdioma] = useState(() => {
        return (
            localStorage.getItem('idioma') || 'es'
        );
    });

    useEffect(() => {
        localStorage.setItem('idioma', idioma);

        document.documentElement.lang = idioma;
    }, [idioma]);

    const cambiarIdioma = (nuevoIdioma) => {
        if (
            nuevoIdioma === 'es' ||
            nuevoIdioma === 'en'
        ) {
            setIdioma(nuevoIdioma);
        }
    };

    const t = (ruta) => {
        const traduccion = obtenerTraduccion(
            traducciones[idioma],
            ruta
        );

        return traduccion || ruta;
    };

    return (
        <IdiomaContext.Provider
            value={{
                idioma,
                cambiarIdioma,
                t,
            }}
        >
            {children}
        </IdiomaContext.Provider>
    );
}

export function useIdioma() {
    const contexto = useContext(IdiomaContext);

    if (!contexto) {
        throw new Error(
            'useIdioma debe utilizarse dentro de IdiomaProvider.'
        );
    }

    return contexto;
}